import React from 'react';
import Employees from '@gp/pages/Pipeline/ProjectDetails/Stakeholder/components/StakeholderDetails/components/Employees';
import { IDepartmentsPropsType } from '@gp/pages/Pipeline/ProjectDetails/Stakeholder/types';
import { getFullOwnerName } from '@gp/pages/Pipeline/ProjectDetails/Stakeholder/utils';

const Departments: React.FC<IDepartmentsPropsType> = (props) => {
  const { organization, departments } = props;

  if (!Array.isArray(departments) || !departments.length) return null;

  return (
    <ul className="dbg-department-list">
      {departments?.map((department: any) => (
        <li key={department?.project_owner} className="department-item">
          <div className="department-name gp-word-break-word">{getFullOwnerName(organization, department?.project_owner)}</div>
          <Employees organization={organization} employees={department?.list} />
        </li>
      ))}
    </ul>
  );
};

export default React.memo(Departments);
